import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Checkbox from '@material-ui/core/Checkbox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import { Translation } from 'react-i18next'
import store from '../../store'

class NewSalarySelectComponent extends React.Component {
  componentDidMount() {
    this.props.getNewSalaryStart(this.props.selectedUser)
    this.props.selectRowSalary([])
  }

  render() {
    return <NewSalarySelect {...this.props} />
  }
}

const styles = () => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  table: {
    //minWidth: 400,
    minHeight: 220
  },
  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    padding: 4
  },
  tablecell1: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: 'black',
    padding: 4
  }
})

const NewSalarySelect = ({
  newSalary,
  selectRowSalary,
  classes,
  selectedRows,
  // willGetDiscount,
  referrerPersonGetDiscount,
  recommendedPersonGetDiscount
}) => {
  // local state to handle checkbox disabled when raiseing salary
  const [disabled, setDisabled] = React.useState(false)
  const [selectedIndex, setSelectedIndex] = React.useState(-1)
  const [isMaksettu, setIsMaksettu] = React.useState(false)
  const [isLessThan500, setIsLessThan500] = React.useState(false) // KAS-336 Gross salary

  // KAS-336 Handle click checkbox
  const handleClick = (e, index) => {
    selectRowSalary(index)
    const gross_salary_without_vat =
      Math.round(newSalary[index].sumInvWithoutTax * 100) / 100
    const instant_payment = newSalary[index].instant_payment
    const isPartialPay = newSalary[index].isPartial === 1 ? true : false
    const isGroupInvoice = newSalary[index].isGroupInvoice === 1 ? true : false

    if (recommendedPersonGetDiscount) {
      if (e.target.checked && (isPartialPay || isGroupInvoice)) {
        setDisabled(true)
        setSelectedIndex(index)
      } else if (
        e.target.checked &&
        gross_salary_without_vat >= 500 &&
        instant_payment !== 'quick_pay'
      ) {
        setDisabled(true)
        setSelectedIndex(index)
      } else if (
        e.target.checked &&
        ((gross_salary_without_vat < 500 &&
          (!isPartialPay || !isGroupInvoice)) ||
          (gross_salary_without_vat >= 500 && instant_payment === 'quick_pay'))
      ) {
        setDisabled(true)
        setIsLessThan500(true)
      } else if (
        !e.target.checked &&
        ((gross_salary_without_vat < 500 &&
          (!isPartialPay || !isGroupInvoice)) ||
          (gross_salary_without_vat >= 500 &&
            instant_payment === 'quick_pay')) &&
        selectedRows.length > 1
      ) {
        setDisabled(true)
        setIsLessThan500(true)
      } else {
        setDisabled(false)
        setSelectedIndex(-1)
        setIsLessThan500(false)
      }
    }
    // Kas-336 referrer person case
    if (referrerPersonGetDiscount) {
      if (e.target.checked) {
        setDisabled(true)
        setSelectedIndex(index)
      } else {
        setDisabled(false)
        setSelectedIndex(-1)
      }
    }
    if (
      e.target.checked &&
      (newSalary[index].status === 15 ||
        newSalary[index].status === 16 ||
        ((newSalary[index].status === 2 || newSalary[index].status === 24) &&
          (isPartialPay || isGroupInvoice)))
    ) {
      setDisabled(true)
      setSelectedIndex(index)
    } else if (
      e.target.checked &&
      (newSalary[index].status !== 15 ||
        newSalary[index].status !== 16 ||
        ((newSalary[index].status === 2 || newSalary[index].status === 24) &&
          (!isPartialPay || !isGroupInvoice)))
    ) {
      setDisabled(true)
      setIsMaksettu(true)
    } else if (
      !e.target.checked &&
      (newSalary[index].status !== 15 ||
        newSalary[index].status !== 16 ||
        ((newSalary[index].status === 2 || newSalary[index].status === 24) &&
          (!isPartialPay || !isGroupInvoice))) &&
      selectedRows.length > 1
    ) {
      setDisabled(true)
      setIsMaksettu(true)
    } else {
      setDisabled(false)
      setSelectedIndex(-1)
      setIsMaksettu(false)
    }
  }

  // KAS-336 Handle disable checkbox
  const handleDisable = (index) => {
    const gross_salary_without_vat =
      Math.round(newSalary[index].sumInvWithoutTax * 100) / 100
    const instant_payment = newSalary[index].instant_payment
    const isPartialPay = newSalary[index].isPartial === 1 ? true : false
    const isGroupInvoice = newSalary[index].isGroupInvoice === 1 ? true : false

    if (selectedRows.length === 0) {
      return false
    } else {
      if (recommendedPersonGetDiscount && (isPartialPay || isGroupInvoice)) {
        return disabled && selectedIndex !== index
      } else if (
        recommendedPersonGetDiscount &&
        gross_salary_without_vat >= 500 &&
        instant_payment !== 'quick_pay'
      ) {
        return disabled && selectedIndex !== index
      } else if (
        recommendedPersonGetDiscount &&
        ((gross_salary_without_vat < 500 &&
          (!isPartialPay || !isGroupInvoice)) ||
          (gross_salary_without_vat >= 500 && instant_payment === 'quick_pay'))
      ) {
        return disabled && isLessThan500 === false
      } else if (referrerPersonGetDiscount) {
        return disabled && selectedIndex !== index
      }

      if (
        newSalary[index].status === 15 ||
        newSalary[index].status === 16 ||
        ((newSalary[index].status === 2 || newSalary[index].status === 24) &&
          (isPartialPay || isGroupInvoice))
      ) {
        return disabled && selectedIndex !== index
      } else if (
        newSalary[index].status !== 15 ||
        newSalary[index].status !== 16 ||
        ((newSalary[index].status === 2 || newSalary[index].status === 24) &&
          (!isPartialPay || !isGroupInvoice))
      ) {
        return disabled && isMaksettu === false
      }
    }
  }

  return (
    <Translation>
      {(t) => {
        return (
          <div className={classes.root}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell className={classes.tablecell}>
                    {t('newSalary.table')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('newSalary.table2')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {t('newSalary.table3')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {store.getState().adminUser.clearUserInfo
                  ? []
                  : newSalary.map((element, index) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={`${element.invoice_id}+${element.partial_invoice_id}`}
                          style={
                            index % 2
                              ? { background: 'white' }
                              : { background: '#ebf9fa' }
                          }
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              onClick={(e) => handleClick(e, index)}
                              icon={
                                <CheckBoxOutlineBlankIcon fontSize="large" />
                              }
                              checkedIcon={
                                <CheckBoxIcon
                                  fontSize="large"
                                  style={{ fill: '#F67131' }}
                                />
                              }
                              disabled={handleDisable(index)}
                              checked={selectedRows.includes(index)}
                            />
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablecell1}
                          >
                            {element.invoice_id}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablecell1}
                          >
                            {element.company_name}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablecell1}
                          >
                            {element.status === 15 ||
                            ((element.status === 2 || element.status === 24) &&
                              element.isPartial) ? (
                              <>
                                {new Intl.NumberFormat('fi-FI', {
                                  style: 'currency',
                                  currency: 'EUR'
                                }).format(element.sumInvWithTax)}{' '}
                                (*P)
                              </>
                            ) : (element.status === 2 ||
                                element.status === 24) &&
                              element.isGroupInvoice ? (
                              <>
                                {new Intl.NumberFormat('fi-FI', {
                                  style: 'currency',
                                  currency: 'EUR'
                                }).format(
                                  element.sumwithoutTax + element.sumVat
                                )}{' '}
                                (*G)
                              </>
                            ) : (
                              new Intl.NumberFormat('fi-FI', {
                                style: 'currency',
                                currency: 'EUR'
                              }).format(element.sumwithoutTax + element.sumVat)
                            )}
                          </TableCell>
                        </TableRow>
                      )
                    })}
              </TableBody>
            </Table>
          </div>
        )
      }}
    </Translation>
  )
}

NewSalarySelectComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(NewSalarySelectComponent)
